<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <div class="navbar-item">
        <Icon/>
        <div class="title is-4">Thwack <span>Tracker</span></div>
      </div>
      <a role="button" class="navbar-burger burger" :class="{ 'is-active': isActive }" aria-label="menu" aria-expanded="false" @click="toggleNav()">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="navbar-menu" :class="{ 'is-active': isActive }">
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <router-link v-if="showBackButton" class="button is-rounded is-link nav__back" :to="{ name: 'campaigns' }">
              <span class="icon">
                <i class="fas fa-arrow-left"></i>
              </span>
              <span>Back to List</span>
            </router-link>
            <a class="button is-rounded is-dark nav__logout" v-on:click="logout">
              <span>Logout</span>
              <span class="icon">
                <i class="fas fa-sign-out-alt"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import {mapState} from 'vuex'
import Icon from '../components/Icon.vue'

export default {
  name: 'TopNav',
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    ...mapState(['user']),
    userEmail () {
      return !!this.user ? this.user.email : ''
    },
    showBackButton () {
      return this.$route.meta.showBackButton
    },
  },
  methods: {
    goToList () {
      this.$router.push('/')
    },
    logout () {
      this.$auth.logout().then(() => {
        this.$router.replace('/login')
      })
    },
    toggleNav () {
      this.isActive = (this.isActive) ? false : true
    }
  },
  components: {
    Icon,
  }
}
</script>
<style scoped>
/* .navbar {
  margin-top: 15px;
}
@media (min-width: 769px) {
  .navbar {
    margin-top: 30px;
  }
}
@media (min-width: 1024px) {
  .navbar {
    margin-top: 45px;
  }
} */
/* .nav {
  padding: 0.5em;
  background-image: url(/static/header-eye-l.svg), url(/static/header-eye-r.svg);
  background-position: 20% -67px, 80% -67px;
  background-repeat: no-repeat, no-repeat;
  background-size: auto 180%;
  display: flex;
  justify-content: space-between;
}
.nav__logout {
  margin-left: auto;
} */
.navbar, 
.navbar-menu {
  background: none transparent;
  box-shadow: none;
}
.title, 
.subtitle {
  margin: 0;
  line-height: 1;
}
.title {
  text-transform: lowercase;
}
.title > span {
  display: none;
}
@media (min-width: 769px) {
  .title > span {
    display: inline;
  }
}
.tt-icon {
  max-width: 65px;
  display: flex;
  align-items: center;
  padding-right: 15px;
}
@media (min-width: 769px) {
  .tt-icon {
    max-width: 75px;
  }
}
@media (min-width: 1024px) {
  .tt-icon {
    max-width: 95px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TopNav.vue